// extracted by mini-css-extract-plugin
module.exports =  {"yTable":"yTable__jZz3X","paginationArrow":"paginationArrow__f2a1w","tableLoader":"tableLoader__2H6Ur"};